<template>
  <div id="app" class="app">
    <router-view />
  </div>
</template>
<script>
import initUserDeviceInfo from '@/plugins/userDeviceInfo';

export default {
  async created() {
    // 初始化initialOidc
    this.$store.dispatch('initialOidc');
    // 先清除在localStorage中不完整授權的請求
    this.$store.dispatch('clearIncompleteAuthorize');
    // 偵測手機高度
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    initUserDeviceInfo();
  },
};
</script>

<style>
.app {
  font-family: apple-system, BlinkMacSystemFont,Microsoft JhengHei,Noto Sans,
  'Helvetica Neue','Helvetica,Arial','Apple Color Emoji', 'Segoe UI Emoji',
  'Segoe UI Symbol','Noto Color Emoji';
}
.app img {
  width: 100%;
  height: auto;
  vertical-align: bottom;
}
.main-button,.sub-button {
  border: none;
  line-height: 40px;
  padding: 0 4px;
  border-radius: 4px;
  text-decoration: none;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.main-button {
  background-color: #FFB13B;
  color: #fff;
}
.main-button[disabled="disabled"] {
  background-color: #f0f0f0;
  color: #b7b7b7;
}
.sub-button {
  color: #4f4f4f;
  border: 1px solid #d4d4d4;
}
.relative{
  position: relative;
}
@media screen and (min-width:480px) {
  .app{
    position: relative;
    max-width: 480px;
    flex-grow: 1;
  }
  body{
    display: flex;
    justify-content: center;
  }
}
</style>
